<!-- Migrado -->
<template>
  <el-collapse v-model="collapseModel">
    <elemento-header
      :title="title"
      :name="name"
    >
      <input-suaje
        v-model="localModel"
        :validate="validarSolicitudCampos"
        v-bind="componentsProps.InputSuaje"
        @update:unidadImposicion="onUnidadImposicionChange"
      />

      <el-row :gutter="24">
        <input-familia-material
          v-model="localModel.MateriaPrimaFamilia"
          :disabled="
            !!localModel.Suaje?.SuajeMateriaPrimaFamilia?.length &&
            localModel.Suaje.SuajeMateriaPrimaFamilia[0]?.CodigoMateriaPrimaFamilia > 0
          "
          :validar="!validarSolicitudCampos.FamiliaMaterial"
        />
      </el-row>

      <input-procesos
        v-model="localModel.Secciones"
        :elemento-tipo="localModel.ElementoTipo"
      />
      <el-divider></el-divider>
    </elemento-header>
  </el-collapse>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import {
  provide,
  computed,
} from 'vue';
import { useElemento } from '@/shared/composables/useElemento.js';
import { useRequestStore } from '@/views/requests/stores/request_store.js';
import { useUnidadImposicionProvider } from '@/shared/composables/use_unidad_imposicion.js';
import InputFamiliaMaterial from '@/shared/components/input_familia_material.vue';
import InputProcesos from '@/shared/components/procesos/input_procesos.vue';
import InputSuaje from '@/shared/components/suaje/input_suaje.vue';
import { useComponentsProps } from '@/shared/composables/use_components_props.js';
import { Modules } from '@/enum/modules';
import { ElementoBase } from '@/enum/elemento_base';

const emit = defineEmits(['update:modelValue']);

const requestStore = useRequestStore();
const { validarSolicitudCampos } = storeToRefs(requestStore);
const { componentsProps } = useComponentsProps(ElementoBase.LIBRO_INTERNO, Modules.SOLICITUD);

const props = defineProps({
  modelValue: { type: Object, required: true },
  title: { type: String, required: true },
  name: { type: String, required: true },
});

const { localModel, collapseModel, updateModelo } = useElemento(props, emit);

// Proveer valores de imposición para componentes de proceso
const imposicionProvidedValue = computed(() => ({
  EtiquetasEje: localModel.value.EtiquetasEje || 0,
  EtiquetasDesarrollo: localModel.value.EtiquetasDesarrollo || 0,
}));

provide('currentElementoBase', ElementoBase.LIBRO_INTERNO);
provide('imposicion', imposicionProvidedValue);
const { onUnidadImposicionChange } = useUnidadImposicionProvider(localModel);
</script>
